<section class="hero-section gradient py-5 py-lg-6 my-5">
    <div class="container h-100">
        <div class="row h-100 align-items-center">
            <!-- Left Content -->
            <div class="col-lg-6 col-md-12">
                <div class="hero-content pe-lg-5">
                    <div [innerHtml]="body()?.primary?.title | renderHtml"></div>

                    <div [innerHtml]="body()?.primary?.description | renderHtml"></div>

                    <app-link [link]="body()?.primary?.button_link" [action]="body()?.primary?.button_action">{{
                        body()?.primary?.button_title
                    }}</app-link>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="floating-items-container p-4">
                    @for (item of body()?.items; track idx; let idx = $index) {
                    <div
                        class="floating-item"
                        [class.offset-right]="idx % 2 === 0"
                        [class.offset-left]="idx % 2 === 1"
                        [style.animation-delay]="idx * 0.3 + 's'"
                    >
                        <div class="item-card d-flex align-items-center justify-content-between py-4">
                            <div class="item-content d-flex align-items-center">
                                <span class="item-number me-3">#{{ idx + 1 }}</span>
                                <span class="fw-bold">{{ item?.building_block }}</span>
                            </div>
                            <div class="check-icon">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M20 6L9 17L4 12"
                                        stroke="#E91E63"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</section>
